import React from 'react';
import NameCard from '../NameCard/NameCard';
import './ResultsContainer.css';
const ResultsContainer = ({ suggestedNames }) => {
    const suggestNameJsx = suggestedNames.map((suggestedName) => {
        return <NameCard key={suggestedName} suggestedName={suggestedName} />;
    });
    return (
        <div>
            <div className="results-container">{suggestNameJsx}</div>
        </div>
    );
};

export default ResultsContainer;
